class XolaOrder {

  saveOrderToBrowser(orderResponse) {
    console.log("orderResponse: " + orderResponse);
    const items = orderResponse["items"];

    const orderId = orderResponse["id"];
    // const orderExperienceId = items["experience"]["id"];
    // const orderReleaseHoldAt = orderResponse["releaseHoldAt"];
    // const orderNumGuests = items["quantity"];
    const orderAmount = orderResponse["amount"];
    // const orderExpName = items["name"];
    const orderStatus = items["status"];
    // console.log(orderStatus);
    // const orderTicketPrice = items["priceScheme"]["price"];
    // const orderArrivalDate = items["arrival"];
    // let orderTimeslot = items["arrivalTime"];
    // orderTimeslot = addLeadingZeroToMilitaryTimeIfNeeded(orderTimeslot)
    // console.log(orderTimeslot);
    sessionStorage.setItem("orderId", orderId);
    // sessionStorage.setItem("orderExperienceId", orderExperienceId);

    // const MS_PER_MINUTE = 60000;
    // const orderHoldDateFormat = new Date(orderReleaseHoldAt);
    // sessionStorage.setItem("orderReleaseHoldAt", orderHoldDateFormat);

    // let bonusMinutes;
    // if (sessionStorage.getItem("devMode") === "1") {
    //   bonusMinutes = 0
    // } else {
    //   bonusMinutes = 5
    // }
    // const fakeReleaseHoldAt = new Date(orderHoldDateFormat - bonusMinutes * MS_PER_MINUTE);
    // console.log("fakeReleaseHoldAt=" + fakeReleaseHoldAt);
    // sessionStorage.setItem("fakeReleaseHoldAt", fakeReleaseHoldAt);
    // sessionStorage.setItem("orderNumGuests", orderNumGuests);
    sessionStorage.setItem("orderAmount", orderAmount);
    // sessionStorage.setItem("orderTicketPrice", orderTicketPrice);
    // sessionStorage.setItem("orderExpName", orderExpName);
    sessionStorage.setItem("orderStatus", orderStatus);

    // sessionStorage.setItem("orderArrivalDate", orderArrivalDate);
    // console.log(orderArrivalDate)
    // const orderArrivalDateLong = dayjs(orderArrivalDate).format("dddd, MMMM D, YYYY")
    // sessionStorage.setItem("orderArrivalDateLong", orderArrivalDateLong);

    // console.log(orderTimeslot)
    // console.log(parseFloat(orderTimeslot))
    // sessionStorage.setItem("orderTimeslot", orderTimeslot);


    // const orderTime`SlotColon = dayjs(orderTimeslot, 'Hmm', true).format("HH:mm")

    // const orderTimeSlotColon = addColonToTime(orderTimeslot);
    // console.log(orderTimeSlotColon)

    // const cs = new CurrentSelection();

    // const arrivalOffset = cs.arrivalOffset;
    // const earlyArrivalTime = dayjs(orderTimeSlotColon, 'HH:mm', true).subtract(arrivalOffset, "m").format("h:mm A")
    // console.log(earlyArrivalTime);

    // const orderTimeSlotStandard = dayjs(orderTimeSlotColon, 'HH:mm', true).format("h:mm A")
    // console.log(orderTimeSlotStandard)
    // sessionStorage.setItem("orderTimeSlotStandard", orderTimeSlotStandard);
    // sessionStorage.setItem("orderArrivalTimeStandard", earlyArrivalTime);
    // console.log(sessionStorage.getItem("orderTimeslot"));
    // console.log(sessionStorage.getItem("orderTimeSlotStandard"));
    // console.log(sessionStorage.getItem("orderArrivalTimeStandard"));

    // sessionStorage.setItem("orderTwoMinWarning", 0)
    sessionStorage.setItem("items", JSON.stringify(orderResponse["items"]))

    // sessionStorage.setItem("postId", cs.postId)

  }

  static getOrderId() {
    return sessionStorage.getItem("orderId")
  }

  static getApiToken() {
    return sessionStorage.getItem("tApiKey")
  }

}
